import * as moment from "moment";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";
import Player from "source/app/domain/Player";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { GetNewFreeTimeEvents } from "./CreateFreeTimeEvents";
import { GetStartOfHour } from "./GetEstimatedStartTime";

export function GetFreeTimeCalendarEvents(eventData: ICalendarEvent[]) {
    const calendarEvents = eventData.map((event) => new CalendarEvent(event));

    const todaysEvents = calendarEvents.filter(
        (calendarEvent) => calendarEvent.IsToday && !calendarEvent.IsAllDay
    );

    const freeHourNumbers = GetFreeHourNumbers(todaysEvents);
    const freeTimeEvents: ICalendarEvent[] = [];

    freeHourNumbers.forEach((freeHour) => {
        const freeTimeStartTime = GetStartOfHour(freeHour);
        const freeTimeEndTime = GetStartOfHour(freeHour + 1);

        const newFreeTimeEvents = GetNewFreeTimeEvents(
            freeTimeStartTime,
            freeTimeEndTime
        );

        freeTimeEvents.push(...newFreeTimeEvents);
    });

    return freeTimeEvents;
}

function GetFreeHourNumbers(todaysEvents: CalendarEvent[]) {
    const occupiedHourNumbersSet = new Set<number>();

    todaysEvents.forEach((event) => {
        event.OccupiedHourNumbers().forEach((hour) => {
            occupiedHourNumbersSet.add(hour);
        });
    });

    const occupiedHourNumbers = Array.from(occupiedHourNumbersSet);

    const allHourNumbers = Array.from(
        { length: Player.endingHour - Player.startingHour },
        (_, index) => index + Player.startingHour
    );

    const freeHourNumbers = allHourNumbers.filter(
        (hour) => !occupiedHourNumbers.includes(hour) && hour >= moment().hour()
    );

    return freeHourNumbers;
}
